import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// init firebase class
// if you need extends these clasees
// eslint-disable-next-line
import { firebase_config_dev as development } from "./firebase-config-dev.js";
// eslint-disable-next-line
import { firebase_config_prod as production } from "./firebase-config-prod.js";
import { firestore_config } from "./firestore-config.js";

if (process.env.NODE_ENV === "development") {
  firebase.initializeApp(development);
} else {
  firebase.initializeApp(production);
}

const store = firebase.firestore();
export const store_util = firebase.firestore;
export const firebase_auth = firebase.auth();
export const firebase_id = firebase.app().id;

export function connectPearents(uid = "") {
  return store
    .collection(firestore_config.pearent)
    .doc(uid)
    .collection("has");
}

export function connectProducts(uid = "", ivent_key = "") {
  return connectPearents(uid)
    .doc(ivent_key)
    .collection("has");
}
